import { useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";

const LABELS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun"];
const VALUES = [33, 53, 85, 41, 44, 65];

export default function LineChart() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const fill = ctx.createLinearGradient(0, 0, 0, 260);
    fill.addColorStop(0, "rgba(113, 61, 255, 0.45)");
    fill.addColorStop(1, "rgba(113, 61, 255, 0)");

    const chart = new Chart(canvas, {
      type: "line",
      data: {
        labels: LABELS,
        datasets: [
          {
            label: "Profit, $B",
            data: VALUES,
            borderColor: "#8b5cff",
            backgroundColor: fill,
            borderWidth: 2,
            fill: true,
            tension: 0.4,
            pointRadius: 0,
            pointHoverRadius: 4,
            pointHoverBackgroundColor: "#f95acc",
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: {
          y: {
            beginAtZero: true,
            grid: { color: "rgba(255,255,255,0.06)" },
            ticks: { color: "#babcd2" },
          },
          x: {
            grid: { display: false },
            ticks: { color: "#babcd2" },
          },
        },
      },
    });

    return () => chart.destroy();
  }, []);

  return (
    <div className="chart-container">
      <canvas
        ref={canvasRef}
        role="img"
        aria-label="Staking and farming profits over the last six months, rising from 33 to 65 billion dollars."
      />
      <table className="sr-only">
        <caption>Monthly staking/farming profit ($B)</caption>
        <thead>
          <tr>
            <th scope="col">Month</th>
            <th scope="col">Profit ($B)</th>
          </tr>
        </thead>
        <tbody>
          {LABELS.map((label, i) => (
            <tr key={label}>
              <th scope="row">{label}</th>
              <td>{VALUES[i]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
